import React from "react";
import PropTypes from "prop-types";

const CartSquiggle = ({ className, color }) => (
  <svg className={className} viewBox="0 0 395 5">
    <g
      id="Product-Store-Cart"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Desktop-Copy-3"
        transform="translate(-846.000000, -314.000000)"
        stroke="#EF5518"
        strokeWidth="2"
      >
        <path d="M1241,315 C1228.65575,315 1228.65575,318 1216.31181,318 C1203.9682,318 1203.9682,315 1191.6246,315 C1179.28099,315 1179.28099,318 1166.93738,318 C1154.59345,318 1154.59345,315 1142.25016,315 C1129.90591,315 1129.90591,318 1117.56165,318 C1105.21837,318 1105.21837,315 1092.87476,315 C1080.5305,315 1080.5305,318 1068.18657,318 C1055.84296,318 1055.84296,315 1043.49935,315 C1031.15575,315 1031.15575,318 1018.81214,318 C1006.46853,318 1006.46853,315 994.125242,315 C981.780987,315 981.780987,318 969.43641,318 C957.093124,318 957.093124,315 944.749515,315 C932.405261,315 932.405261,318 920.061329,318 C907.71772,318 907.71772,315 895.374112,315 C883.030503,315 883.030503,318 870.686894,318 C858.343286,318 858.343286,315 846,315"></path>
      </g>
    </g>
  </svg>
);

CartSquiggle.defaultProps = {
  className: ``,
  color: `black`
};

CartSquiggle.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default CartSquiggle;
